<template>
  <div></div>
</template>
<script>
const serverSrc = 'https://www.awesomewholesale.com.au'
// const serverSrc = 'http://192.168.31.102:18080'
export default {
  serverSrc
}
</script>
<style lang="scss" scoped>

</style>
